import { apiPost } from 'ApiPackage/MainModule/common/apiTools';
import { config } from 'CorePackage/MainModule/constants/config';

import { IFeedback } from '../interfaces/IFeedback';

export async function postFeedback({ captchaToken, ...props }: IFeedback) {
  return apiPost({ url: `${config.server}/feedback`, body: props, token: captchaToken });
}
